import { Routes, Route } from "react-router-dom";
import { useState } from "react";

import Layout from "./components/Layout";
import SplashScreen from "./components/SplashScreen";

// Pages
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Upsarpanch from "./pages/Upsarpanch";
import Sarpanch from "./pages/Sarpanch";
import MrutDakhala from "./pages/MrutDakhala";
import JanmDakhala from "./pages/JanmDakhala";
import VivahDakhala from "./pages/VivahDakhala";
import GramsevakPage from "./pages/GramsevakPage";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import GPTeam from "./pages/GPTeam";
import VikasKame from "./pages/VikasKame";
import GramPanchayatNamuna8 from "./pages/GramPanchayatNamuna8";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <Routes>
      {showSplash ? (
        <Route
          path="*"
          element={
            <SplashScreen
              onFinish={() => setShowSplash(false)}
            />
          }
        />
      ) : (
        <>
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />

          <Route
            path="/aboutus"
            element={
              <Layout>
                <AboutUs />
              </Layout>
            }
          />

          <Route
            path="/sarpanch"
            element={
              <Layout>
                <Sarpanch />
              </Layout>
            }
          />

          <Route
            path="/upsarpanch"
            element={
              <Layout>
                <Upsarpanch />
              </Layout>
            }
          />

          <Route
            path="/sachiv"
            element={
              <Layout>
                <GramsevakPage />
              </Layout>
            }
          />

          <Route
            path="/gallery"
            element={
              <Layout>
                <Gallery />
              </Layout>
            }
          />

          <Route
            path="/mrut-dakhala"
            element={
              <Layout>
                <MrutDakhala />
              </Layout>
            }
          />

          <Route
            path="/janm-dakhala"
            element={
              <Layout>
                <JanmDakhala />
              </Layout>
            }
          />

          <Route
            path="/vivah-dakhala"
            element={
              <Layout>
                <VivahDakhala />
              </Layout>
            }
          />

          <Route
            path="/contact"
            element={
              <Layout>
                <Contact />
              </Layout>
            }
          />

          <Route
            path="/team"
            element={
              <Layout>
                <GPTeam />
              </Layout>
            }
          />

          <Route
            path="/devlopment"
            element={
              <Layout>
                <VikasKame />
              </Layout>
            }
          />

          <Route
            path="/namuna"
            element={
              <Layout>
                <GramPanchayatNamuna8 />
              </Layout>
            }
          />
        </>
      )}
    </Routes>
  );
}

export default App;